var toggleEllipsis = (el) => {
  // set some variables
  const ellipses = el.closest('div').querySelector('.ellipsis'),
        text = el.innerText,
        altText = el.getAttribute('data-alt');
  // swap trigger text
  el.setAttribute('data-alt', text);
  el.innerText = altText;
  // toggle collapsed state
  ellipses.classList.toggle('collapsed');
};